export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./index.vue?vue&type=template&id=33d845a1&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/pages/lk/competencies/index.vue?vue&type=template&id=33d845a1&
// module id = 1136
// module chunks = 0